export const wsHost = process.env.WS;
export const dashHost = process.env.DASH_HOST;
